import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pageId, url } from "../../../routes";
import {
  BreadcrumbShowCountlabel,
  commonPageFieldList,
  commonPageFieldListSuccess
} from "../../../store/actions";
import CommonListPage from "../../../components/Common/CommonMasterListPage";
import GenericMessageMaster from "./GenricMaster";
import {
  deleteGenericMessage,
  deleteGenericMessageSuccess,
  editGenericMessage,
  getGenericMessageList,
  resetGenericMessageState,
  saveGenericMessage,
  saveGenericMessageSuccess,
  updateGenericMessage,
  updateGenericMessageSuccess
} from "../../../store/Administrator/GenericMessageRedux/action";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { PageLoadingSpinner } from "../../../components/Common/CommonButton";

const GenericMassagesList = () => {

  const dispatch = useDispatch();
  const [updateData, setUpdateData] = useState([]);

  

  // -------------------------
  // Redux State
  // -------------------------
  const reducers = useSelector((state) => ({
    listBtnLoading: state.GenericMessageReducer.listBtnLoading,
    tableList: state.GenericMessageReducer.GenericMessageList,
    editData: state.GenericMessageReducer.editData,
    deleteMsg: state.GenericMessageReducer.deleteMessage,
    postMsg: state.GenericMessageReducer.PostData,
    userAccess: state.Login.RoleAccessUpdateData,
    updateMsg: state.GenericMessageReducer.updateMessage,
    pageField: state.CommonPageFieldReducer.pageFieldList,
  }));
  // -------------------------
  // Actions for CommonListPage
  // -------------------------
  const action = {
    editId: editGenericMessage,
    deleteId: deleteGenericMessage,
    getList: getGenericMessageList,
    postSucc: saveGenericMessageSuccess,
    updateSucc: updateGenericMessageSuccess,
    deleteSucc: deleteGenericMessageSuccess,
  };
  

  
  

  // -------------------------
  // DateTime formatter (DISPLAY ONLY)
  // -------------------------
  const formatDateTime = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "";

    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };


  //  DELETE ERROR (400) – Master page reference pattern
useEffect(() => {

  if (
    reducers.deleteMsg?.Status === false &&
    reducers.deleteMsg?.StatusCode === 400
  ) {

    //  backend message show
    customAlert({
      Type: 3, // error
      Message: reducers.deleteMsg.Message,
    });

    //  reset (same as master page)
    dispatch(deleteGenericMessageSuccess({ Status: false }));
  }

}, [reducers.deleteMsg, dispatch]);


  // -------------------------
  // Cleanup on unmount
  // -------------------------
  useEffect(() => {
    return () => {
      dispatch(resetGenericMessageState());
    };
  }, [dispatch]);

  // -------------------------
  // Get List API
  // -------------------------
  useEffect(() => {
    dispatch(getGenericMessageList({
      jsonBody: JSON.stringify({
        ActiveMessages: 0,
        Party: 0,
      }),
    }));
  }, [dispatch]);

  // -------------------------
  // Page Field
  // -------------------------
  useEffect(() => {
    const page_Id = pageId.GENERIC_MESSAGE_LIST;
    dispatch(commonPageFieldListSuccess(null));
    dispatch(commonPageFieldList(page_Id));

    return () => {
      dispatch(commonPageFieldListSuccess(null));
    };
  }, [dispatch]);

  // -------------------------
  // Format table data for display
  // -------------------------
  useEffect(() => {
    const formattedData = Array.isArray(reducers.tableList)
      ? reducers.tableList.map((row) => ({
          ...row,
          ValidFrom: formatDateTime(row.ValidFrom),
          ValidTo: formatDateTime(row.ValidTo),
        }))
      : [];

    setUpdateData(formattedData);
    dispatch(BreadcrumbShowCountlabel(`Count:${formattedData.length}`));
  }, [reducers.tableList, dispatch]);

  // -------------------------
  // Render
  // -------------------------
  return (
    <React.Fragment>
      <PageLoadingSpinner isLoading={ !reducers.pageField} />
      {reducers.pageField && (
        <CommonListPage
          action={action}
          reducers={{
            ...reducers,
            tableList: updateData, //  formatted data
          }}
          newBtnPath={url.GENERIC_MESSAGE_MASTER}
          MasterModal={GenericMessageMaster}
          masterPath={url.GENERIC_MESSAGE_MASTER}
          ButtonMsgLable={"GENERIC_MESSAGE_MASTER"}
          deleteName={"MessageText"}
         
        />
      )}
    </React.Fragment>
  );
};

export default GenericMassagesList;
